<template>
	<div class="container container_shop">
		<!-- 头部导航 -->
		<div class="header" :style="{ background: `rgba(255, 255, 255,${headerOpacity})` }">
			<div class="nav-bar">
				<div class="nav-left">
					<img src="@/assets/ecny/Pandapass_logo.png" alt="Pandapass" class="logo" />
				</div>
				<div class="nav-right">
					<LanguageSwitch />
				</div>
			</div>
		</div>

		<!-- Banner区域 -->
		<div class="banner-area">
			<van-swipe class="banner-swipe" indicator-color="white">
				<van-swipe-item v-for="(banner, index) in bannerList" :key="index" class="banner-item" @click="goToBanner(banner)">
					<img :src="banner.image_url" :alt="banner['title_' + $i18n.locale]" class="banner-image" @dragstart.prevent />
				</van-swipe-item>
			</van-swipe>
		</div>

		<!-- 分类标签 -->
		<div class="category-tabs" ref="categoryTabs" :class="{ 'sticky-active': isTabbarSticky }">
			<div class="tab-item" v-for="item in category_tabs" :key="item.id" :ref="`tab-${item.id}`" :class="{ active: activeTab === item['id'] }" @click="setActiveTab(item['id'])">
				{{ item["name_" + $i18n.locale] }}
			</div>
		</div>

		<!-- 商品网格（支持下拉刷新） -->
		<van-pull-refresh v-model="isRefreshing" @refresh="onRefresh" :pulling-text="$t('refresh.pulling')" :loosing-text="$t('refresh.loosing')" :loading-text="$t('refresh.loading')">
			<div class="content">
				<div class="shop-grid">
					<div class="shop-item" v-for="item in currentShopItems" :key="item.id" @click="goToProductDetail(item)">
						<div class="item-image">
							<div class="image-placeholder">
								<img :src="item.cover" alt="商品图片" />
							</div>
						</div>
						<div class="item-info">
							<h3 class="item-name">{{ item[`name_${$i18n.locale}`] }}</h3>
							<div class="item-price">¥ {{ Number(item.currentPrice) }}</div>
						</div>
					</div>
				</div>
			</div>
		</van-pull-refresh>

		<!-- 固定购物车（仅登录后显示） -->
		<div class="fixed-cart" v-if="isLoggedIn" ref="cartButton" @click="goToCart()">
			<van-icon name="shopping-cart-o" />
			<div class="badge" v-if="cartCount > 0">{{ cartCount }}</div>
		</div>
	</div>
</template>

<script>
	import { getUserInfoSafe, getToken, requireLogin } from "@/utils/auth.js";
	import "@vant/touch-emulator";
	export default {
		name: "ShopView",
		data() {
			return {
				activeTab: "",
				isTabbarSticky: false,
				headerOpacity: 0,
				scrollHeight: 100,
				isRefreshing: false,
				isLoggedIn: false,
				cartCount: 0,
				category_tabs: [],
				allShopItems: {},
				allShopItemsList: [],
				user_id: "",
				bannerList: [], // banner 图片列表
			};
		},
		mounted() {
			const info = getUserInfoSafe();
			if (info) {
				this.user_id = info.id;
			}
			this.setActiveTab(this.activeTab);
			this.stickyEl = document.querySelector(".category-tabs");
			this.stickyTop = parseInt(getComputedStyle(this.stickyEl).top, 10);
			this.container_shop = document.querySelector(".container_shop");
			//页面滚动，当tabbar吸顶的时候，header的背景不透明度逐渐变得不透明
			this.container_shop.addEventListener("scroll", (e) => {
				this.handleScroll_shop(e);
			});
			this.getCategory();
			this.getBannerList();
			this.checkLoginAndLoadCart();
		},
		computed: {
			currentShopItems() {
				if (this.activeTab === 0) {
					return this.allShopItemsList;
				}
				return this.allShopItems[this.activeTab] || [];
			},
		},
		activated() {
			requireLogin(this);
			this.checkLoginAndLoadCart();
		},
		methods: {
			setActiveTab(tab) {
				this.activeTab = tab;
				this.$nextTick(() => {
					this.centerActiveTab();
				});
			},
			centerActiveTab() {
				const container = this.$refs.categoryTabs;
				if (!container) return;
				const tabEl = this.$refs[`tab-${this.activeTab}`];
				const el = Array.isArray(tabEl) ? tabEl[0] : tabEl;
				if (!el) return;
				const containerRect = container.getBoundingClientRect();
				const elRect = el.getBoundingClientRect();
				const offset = elRect.left - containerRect.left + elRect.width / 2 - containerRect.width / 2;
				container.scrollTo({ left: container.scrollLeft + offset, behavior: "smooth" });
			},
			handleScroll_shop(e) {
				let scrollTop = e.target.scrollTop;
				let rect = this.stickyEl.getBoundingClientRect();
				// 当元素距离视口顶部的距离等于 sticky 的 top 值时，认为“吸顶”了
				if (rect.top <= this.stickyTop) {
					this.isTabbarSticky = true;
				} else {
					this.isTabbarSticky = false;
				}
				// 计算header透明度
				if (scrollTop > this.scrollHeight) {
					this.headerOpacity = 1;
				} else {
					//按照比例计算
					this.headerOpacity = scrollTop / this.scrollHeight;
				}
			},
			goToCart() {
				this.$router.push("/shopCart");
			},
			checkLoginAndLoadCart() {
				// 使用工具方法读取 token
				const token = getToken();
				this.isLoggedIn = !!token;
				if (this.isLoggedIn) {
					this.loadCartCount();
				} else {
					this.cartCount = 0;
				}
			},
			loadCartCount() {
				this.$api
					.postData("/shop/get_cart_count", {
						user_id: this.user_id,
					})
					.then((res) => {
						this.cartCount = Number(res.data || 0);
					})
					.catch(() => {
						this.cartCount = 0;
					});
			},
			goToProductDetail(item) {
				this.$router.push(`/product/${item.id}`);
			},
			onRefresh() {
				// 重新拉取当前分类数据
				const currentCategory = this.activeTab;
				this.getData(currentCategory);
				// 刷新时同步更新购物车数量（若已登录）
				if (this.isLoggedIn) {
					this.loadCartCount();
				}
				// 简单延迟以展示加载状态
				setTimeout(() => {
					this.isRefreshing = false;
				}, 500);
			},
			getData(categoryId) {
				this.$api
					.postData("/shop/get_shop_data", {
						category_id: categoryId,
					})
					.then((res) => {
						console.log(res);
						this.allShopItemsList = res.data;
						//将数据按分类分组 category_id
						const groupedByCategory = {};
						res.data.forEach((prod) => {
							const category_id = prod.category_id;
							if (!groupedByCategory[category_id]) groupedByCategory[category_id] = [];
							groupedByCategory[category_id].push(prod);
						});

						this.allShopItems = groupedByCategory;
					})
					.catch((err) => {
						console.error("get_shop_data error:", err);
					});
			},
			getCategory() {
				this.$api.postData("/shop/get_shop_category", {}).then((res) => {
					this.category_tabs = Array.isArray(res.data) ? res.data : [];
					this.category_tabs.unshift({ id: 0, name_en: "All", name_zh: "全部" });
					if (this.category_tabs.length > 0) {
						this.activeTab = this.category_tabs[0].id;
						this.getData(this.activeTab);
					}
				});
			},
			getBannerList() {
				this.$api
					.postData("/shop/get_shop_banner", {})
					.then((res) => {
						if (res && res.code === 200) {
							this.bannerList = Array.isArray(res.data) ? res.data : [];
						}
					})
					.catch((err) => {
						console.error("获取banner数据失败:", err);
						this.bannerList = [];
					});
			},
			goToBanner(banner) {
				if (banner.external_url) {
					//打开新的页面
					window.open(banner.external_url, "_blank");
				} else {
					console.log(banner.product_id);
					this.$router.push(`/product/${banner.product_id}`);
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	.container {
		font-family: "D-DINExp";
		position: relative;
		overflow: hidden auto;
		height: calc(100vh - 68px - env(safe-area-inset-bottom));
	}

	.header {
		position: sticky;
		top: 0;
		background: white;
		padding: 20px;
		z-index: 10;

		.nav-bar {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.nav-left {
				display: flex;
				align-items: center;
				gap: 8px;

				.logo {
					width: 136px;
					object-fit: contain;
				}
			}
		}
	}

	.banner-area {
		padding: 20px 16px 0px;
		.banner-swipe {
			width: 100%;
			height: 120px;
			border-radius: 20px;
			overflow: hidden;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

			.banner-item {
				width: 100%;
				height: 100%;

				.banner-image {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
		}
	}

	.category-tabs {
		position: sticky;
		top: 66px;
		display: flex;
		padding: 20px 16px 20px;
		gap: 10px;
		z-index: 10;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		scrollbar-width: none;
		-ms-overflow-style: none;
		&::-webkit-scrollbar {
			display: none;
		}
		&.sticky-active {
			background: rgb(255, 255, 255);
		}
		.tab-item {
			flex-shrink: 0;
			min-width: 60px;
			padding: 0 20px;
			height: 35px;
			background: #f7f0f0;
			color: #333;
			text-align: center;
			border-radius: 25px;
			font-size: 14px;
			font-weight: 500;
			cursor: pointer;
			transition: all 0.3s ease;
			border: 1px solid #ea301700;
			display: flex;
			justify-content: center;
			align-items: center;
			&.active {
				background: white;
				color: #333;
				border: 1px solid #ea2e17;
			}
		}
	}

	.content {
		padding: 0 16px 60px;

		.shop-grid {
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			gap: 15px;

			.shop-item {
				background: white;
				border-radius: 15px;
				overflow: hidden;
				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
				position: relative;
				cursor: pointer;
				transition: transform 0.3s ease;

				&:hover {
					transform: translateY(-2px);
				}

				.item-image {
					width: 100%;
					height: 120px;
					overflow: hidden;

					.image-placeholder {
						width: 100%;
						height: 100%;
						background: #f0f0f0;
						img {
							width: 100%;
							height: 100%;
							object-fit: cover;
						}
					}
				}

				.item-info {
					padding: 15px 10px;

					.item-name {
						color: #333;
						font-size: 14px;
						margin: 0 0 8px 0;
						font-weight: 500;
						line-height: 1.3;

						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.item-price {
						color: #eb2d16;
						font-size: 16px;
						font-weight: bold;
					}
				}

				// 移除旧的购物车样式
			}
		}
	}

	// 固定购物车样式
	.fixed-cart {
		position: sticky !important;
		bottom: 120px !important;
		right: 20px !important;
		left: auto !important;
		top: auto !important;
		margin-left: auto;
		width: 50px;
		height: 50px;
		background: white;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		cursor: pointer;
		transition: all 0.3s ease;
		transform: none !important;

		&:hover {
			transform: scale(1.1);
			box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
		}

		.van-icon {
			font-size: 24px;
			color: #333;
		}

		.badge {
			position: absolute;
			top: -5px;
			right: -5px;
			background: #eb2d16;
			color: white;
			font-size: 12px;
			font-weight: bold;
			width: 20px;
			height: 20px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
</style>
